<template>
    <div class="pushProject">
        <leftnav class="fl" :mkcode="yj_mkcode" :itemcode="yj_itemcode" docutitle="共享项目"></leftnav>
        <div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
            <govheader></govheader>
            <div class="index_left_centerpage">
                <div class="whitebox right_topbox">
                    <div class="right_boxtitle map_title_tab">
                        <!-- <span :class="currentTab == '' ? 'current title' : 'title'"
                            @click=" currentTab = ''; ajaxsearchcompany(1);">全部项目</span> -->
                        <span :class="currentTab == item.value ? 'current title' : 'title'"
                            v-for="(item) in tabList" @click="navclick(item)" :key="'nav' + item.value">{{ item.text }}
                        </span>
                    </div>
                </div>
                <div class="enterprise_list_box whitebox">
                    <div class="enterparise_guide oh" style="width: 95%; ">
                        <p class="fl">为您找到<span class="searchnum">{{ total }}</span>条相关结果</p>
                    </div>
                    <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
                        <tr>
                            <th>项目名称</th>
                            <th>企业名称</th>
                            <th>项目操作人</th>
                            <th>类型</th>
                            <th>创建时间</th>
                        </tr>
                        <tr v-for="item in enterpristlist" :key="item.stockcode">
                            <td @click="detailrouterto('/workbenchEnterpriseDetails', item.id)" class="title">
                                {{ item.title }}</td>
                            <td>{{ item.companyName }}</td>
                            <td>{{ item.operateUserName }}</td>
                            <td>{{ item.typeText }}</td>
                            <td>{{ item.createTime }}</td>
                        </tr>
                    </table>
                </div>
                <div class="centerpage1 company_pagelist" v-show="totalPage > 1">
                    <zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
                        v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
    name: 'pushProject',
    data() {
        return {
            currentTab: '',
            userdata: {},
            tabList: [
                { value: '', text: '全部',  },
                { value: '1', text: '推送',},
                { value: '2', text: '退回', },
                { value: '3', text: '撤回', },
            ],
            yj_mkcode: 'F',
            yj_itemcode: 'F-tschxm',
            enterpristlist: [],
            page: 1, //显示的是哪一页
            haspage: true, //是否还有下一页
            pageSize: 10, //每一页显示的数据条数
            total: 0, //记录总数
            totalPage: 1,
            maxPage: 10, //最大页数 
            mainUnitList: [],
            secondUnitList: [],
        }
    },
    computed: {
        ...mapState({ isCollapse: (state) => state.isCollapse, }),
        ...mapGetters(['isCollapse'])
    },

    components: {
    },
    mounted() {
        this.ajaxsearchcompany(1);
    },
    created() {
        this.userdata = this.getuseriformation();
    },
    methods: {
        navclick(item) {
            this.currentTab = item.value;
            this.ajaxsearchcompany(1);
        },
        //详情页跳转
        detailrouterto(path, id) {
            if (id == 0 || id == "") {
                return;
            }
            this.routerlinkarry(path, { id: id });
        },
        ajaxsearchcompany(page) {
            this.page = page || 1;
            // 获取项目列表
            this.bus.$emit('loading', true);
            var _this = this;
            let ajaxurl1 = this.$api.crm.pushLog.List() + '?page=' + this.page + '&pageSize=' + this.pageSize+'&type='+this.currentTab;
            this.$axios.get(ajaxurl1, {
                headers: {
                    AuthToken: this.userdata.token
                }
            }).then(function (res) {

                console.log("项目列表", res.data);
                if (res.data.success) {
                    _this.enterpristlist = res.data.list;
                    _this.pageSize = res.data.pageSize//每一页显示的数据条数
                    _this.total = res.data.totalRecord//每一页显示的数据条数
                    _this.totalPage = res.data.totalPage//每一页显示的数据条数

                } else {
                    _this.$message.error(res.data.msg);
                }
                _this.bus.$emit('loading', false);

            }).catch(function (err) {
                console.log(err);
            });
        },
        pageHandler: function (page) {
            this.ajaxsearchcompany(page);
        },
    }
}
</script>

<style scoped lang="scss">
.enterprise_list_box {
    min-height: 75vh;
}

.initiate_box {
    font-size: 16px;
    width: 85%;
    margin: 0 auto;

    ::v-deep {
        &.el-select {
            width: 100%;
        }
    }
}

.initiate_title {
    font-weight: 600;
}

.initiate_box_dialog {
    border-radius: 10px;
}
</style>